import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment-timezone';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IntercomService } from 'app/intercom/intercom.service';
import { FolderNavBarService } from 'app/layout/folder-navbar/folder-navbar.service';
import { UserService } from 'app/user/user.service';

@Component({
  selector: 'cc-account-upgrade-modal',
  templateUrl: 'account-upgrade-modal.component.html',
  styleUrls: ['account-upgrade-modal.component.scss'],
})
export class AccountUpgradeModalComponent implements OnInit, OnDestroy {
  @Input() expiration: number;
  @Input() isPausedOrChurned: boolean;

  trialDaysLeft: string;
  trialExpirationPeriod: number;
  expiredAccount: boolean;
  canSwitchWorkspace = false;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly intercomService: IntercomService,
    public readonly activeModal: NgbActiveModal,
    private readonly folderNavbarService: FolderNavBarService,
    private readonly userService: UserService,
  ) {}

  ngOnInit(): void {
    moment.relativeTimeThreshold('d', 31);
    this.trialDaysLeft = moment(this.expiration).fromNow();
    this.trialExpirationPeriod = this.expiration - new Date().getTime();
    this.expiredAccount = this.isPausedOrChurned || this.trialExpirationPeriod <= 0;
    this.setupCanSwitchWorkspace();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setupCanSwitchWorkspace() {
    const userControllerMap = this.userService.getUserControllerMap();
    if (userControllerMap.isAdmin) {
      this.canSwitchWorkspace = true;
      return;
    }

    this.folderNavbarService
      .getUserCompanies()
      .pipe(takeUntil(this.destroy$))
      .subscribe((companies) => {
        this.canSwitchWorkspace = companies.length > 1;
      });
  }

  openLiveChat() {
    this.intercomService.open();
  }

  switchWorkspace() {
    this.activeModal.close();
  }
}
